import { newsData } from '../../../mocks/news';

export default function NewsSection() {
  const countries = [
    { name: "Россия", casinos: 15, status: "Доступно", color: "green" },
    { name: "Казахстан", casinos: 12, status: "Доступно", color: "green" },
    { name: "Беларусь", casinos: 10, status: "Доступно", color: "green" },
    { name: "Украина", casinos: 8, status: "Ограничено", color: "yellow" },
    { name: "Узбекистан", casinos: 7, status: "Доступно", color: "green" },
    { name: "Азербайджан", casinos: 6, status: "Доступно", color: "green" }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-gray-50 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Новости индустрии онлайн-гейминга
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Актуальные новости о бонусах, акциях и изменениях в казино онлайн
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {newsData.map((news) => (
            <div
              key={news.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:scale-105 group"
            >
              <div className="h-48 bg-gradient-to-br from-orange-400 to-orange-600 relative overflow-hidden">
                <div className="absolute inset-0 flex items-center justify-center">
                  <i className="ri-newspaper-line text-8xl text-white/20"></i>
                </div>
                <div className="absolute top-4 left-4">
                  <span className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-semibold text-orange-600">
                    {news.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="text-sm text-gray-500 mb-2">{news.date}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                  {news.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{news.excerpt}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            Интерактивная карта доступности казино онлайн по странам
          </h3>
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {countries.map((country, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-200"
                >
                  <div className="flex items-center gap-3">
                    <div className={`w-3 h-3 rounded-full ${
                      country.color === 'green' ? 'bg-green-500' : 'bg-yellow-500'
                    }`}></div>
                    <div>
                      <div className="font-bold text-gray-900">{country.name}</div>
                      <div className="text-sm text-gray-600">{country.casinos} казино онлайн</div>
                    </div>
                  </div>
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    country.color === 'green' 
                      ? 'bg-green-100 text-green-700' 
                      : 'bg-yellow-100 text-yellow-700'
                  }`}>
                    {country.status}
                  </span>
                </div>
              ))}
            </div>
            <div className="mt-8 p-4 bg-blue-50 rounded-xl">
              <p className="text-sm text-gray-700 text-center">
                <i className="ri-information-line text-blue-600 mr-2"></i>
                Все представленные казино онлайн работают с игроками из указанных стран. Доступ может различаться в зависимости от региона.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Актуальные акции и бонусы казино онлайн
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center">
                  <i className="ri-calendar-event-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Еженедельные турниры</h4>
                  <p className="text-sm text-gray-600">Призовой фонд до 1 000 000 ₽</p>
                </div>
              </div>
              <p className="text-sm text-gray-700 mb-4">
                Участвуйте в еженедельных турнирах от ведущих казино онлайн. Играйте в любимые слоты и выигрывайте дополнительные призы.
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">Fugu</span>
                <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">SOL</span>
                <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-medium">1GO</span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                  <i className="ri-gift-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Reload бонусы</h4>
                  <p className="text-sm text-gray-600">До 100% на повторные депозиты</p>
                </div>
              </div>
              <p className="text-sm text-gray-700 mb-4">
                Получайте бонусы на каждое пополнение счета. Многие казино онлайн предлагают reload бонусы по понедельникам и пятницам.
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">FRESH</span>
                <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">LEX</span>
                <span className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium">DRIP</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}